module.exports = __webpack_public_path__ + "media/images/emblems/Dachsen-blazon-6e79f499a7fc8d954b636ad7e61ae8cc.svg";